import React, { FC, memo } from 'react';

import { Button, Grid, Paper } from '@material-ui/core';
import useCustomerPayment from 'src/hooks/customer-payment/use-customer-payment';
import { dateToday, downloadCSV } from 'src/utils';
import {
  CommonCustomerPaymentPayload,
  excludedPaymentMode
} from 'src/redux/slices/customer-payment';
import { cloneDeep } from 'lodash';

interface Props {}

const Component: FC<Props> = () => {
  const {
    customerPaymentParams,
    customerPaymentList,
    fetchList,
    exportFetchListData
  } = useCustomerPayment();

  const listEmpty = customerPaymentList?.list?.length <= 0;

  const onHandleExportTransactions = async (
    params: CommonCustomerPaymentPayload,
    last_page: number,
    action: 'payments' | 'transaction'
  ) => {
    const list = await exportFetchListData(params);

    if (!list?.length) return;

    const clonedPaymentList = cloneDeep(list);

    const filteredPaymentList =
      action === 'payments'
        ? clonedPaymentList.map((payment) => ({
            ...payment,
            payments: payment?.payments?.filter(
              (data) => !excludedPaymentMode.includes(data?.payment_type || '')
            )
          }))
        : clonedPaymentList;

    const csvPaymentListData = filteredPaymentList.flatMap((payment) =>
      payment?.payments?.length
        ? payment.payments.map((p) => ({
            payment_date: p.payment_date || 'N/A',
            branch: payment.branch || 'N/A',
            customer: payment.customer || 'N/A',
            si_no: payment.si_no || 'N/A',
            mode_of_payment: p.payment_type || 'N/A',
            amount: p.amount
          }))
        : [
            {
              payment_date: 'N/A',
              branch: payment.branch || 'N/A',
              customer: payment.customer || 'N/A',
              si_no: payment.si_no || 'N/A',
              mode_of_payment: 'N/A',
              amount: 0
            }
          ]
    );

    const csvName = `customer-${action}-${dateToday(
      'MM-dd-yyyy_HH:mm:ss'
    )}.csv`;
    downloadCSV(csvPaymentListData, csvName);
  };

  return (
    <Paper elevation={0} style={{ padding: 20 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            onClick={() => fetchList(customerPaymentParams)}
            disabled={!listEmpty}
          >
            Show List
          </Button>
        </Grid>
        <Grid item xs={12} md={3}></Grid>
        <Grid item xs={12} md={3}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            disabled={listEmpty}
            onClick={() =>
              onHandleExportTransactions(
                customerPaymentParams,
                customerPaymentList?.meta?.last_page || 1,
                'payments'
              )
            }
          >
            Export Payments
          </Button>
        </Grid>
        <Grid item xs={12} md={3}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            disabled={listEmpty}
            onClick={() =>
              onHandleExportTransactions(
                customerPaymentParams,
                customerPaymentList?.meta?.last_page || 1,
                'transaction'
              )
            }
          >
            Export Transaction
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export const Options = memo(Component);
